import { AccountInfo } from "@azure/msal-common";

class AppRolesService {
    isUserAdmin = (accounts: AccountInfo[], isAuthenticated: boolean) => {
        let isAdmin = false;
        if (isAuthenticated && accounts[0] && accounts[0].idTokenClaims) {
            isAdmin = !!accounts[0].idTokenClaims.roles?.includes('admin')
        }

        return isAdmin;
    }

    canUserCreateEnvironments = (accounts: AccountInfo[], isAuthenticated: boolean) => {
        if (this.isUserAdmin(accounts, isAuthenticated))
            return true;

        let canCreateEnv = false;
        if (isAuthenticated && accounts[0] && accounts[0].idTokenClaims) {
            canCreateEnv = !!accounts[0].idTokenClaims.roles?.includes('createEnv')
        }

        return canCreateEnv;
    }

    canUserConfigureACPP = (accounts: AccountInfo[], isAuthenticated: boolean) => {
        if (this.isUserAdmin(accounts, isAuthenticated))
            return true;

        let canConfigureACPP = false;
        if (isAuthenticated && accounts[0] && accounts[0].idTokenClaims) {
            canConfigureACPP = !!accounts[0].idTokenClaims.roles?.includes('configureACPP')
        }

        return canConfigureACPP;
    }

    canUserDeleteEnvironments = (accounts: AccountInfo[], isAuthenticated: boolean) => {
        return this.isUserAdmin(accounts, isAuthenticated);
    }

    canUserLockAppEnvironments = (accounts: AccountInfo[], isAuthenticated: boolean) => {
        if (this.isUserAdmin(accounts, isAuthenticated))
            return true;

        let canLockAppEnv = false;
        if (isAuthenticated && accounts[0] && accounts[0].idTokenClaims) {
            canLockAppEnv = !!accounts[0].idTokenClaims.roles?.includes('lockAppEnv')
        }

        return canLockAppEnv;
    }

    canUserSoftDeleteAcppEnvironments = (accounts: AccountInfo[], isAuthenticated: boolean) => {
        if (this.isUserAdmin(accounts, isAuthenticated))
            return true;

        let canLockAcppEnv = false;
        if (isAuthenticated && accounts[0] && accounts[0].idTokenClaims) {
            canLockAcppEnv = !!accounts[0].idTokenClaims.roles?.includes('softDeleteAcppEnv')
        }

        return canLockAcppEnv;
    }

    canUserConfigureACR = (accounts: AccountInfo[], isAuthenticated: boolean) => {
        if (this.isUserAdmin(accounts, isAuthenticated))
            return true;

        let canConfigureACR = false;
        if (isAuthenticated && accounts[0] && accounts[0].idTokenClaims) {
            canConfigureACR = !!accounts[0].idTokenClaims.roles?.includes('configureACR')
        }

        return canConfigureACR;
    }

    canUserEnableACR = (accounts: AccountInfo[], isAuthenticated: boolean) => {
        if (this.isUserAdmin(accounts, isAuthenticated))
            return true;

        let canEnableACR = false;
        if (isAuthenticated && accounts[0] && accounts[0].idTokenClaims) {
            canEnableACR = !!accounts[0].idTokenClaims.roles?.includes('enableACR') || !!accounts[0].idTokenClaims.roles?.includes('configureACR');
        }
        return canEnableACR;
    }

    isUserAPPReactiveSupport = (accounts: AccountInfo[], isAuthenticated: boolean) => {
        if (this.isUserAdmin(accounts, isAuthenticated))
            return true;

        let canRestore = false;
        if (isAuthenticated && accounts[0] && accounts[0].idTokenClaims) {
            canRestore = !!accounts[0].idTokenClaims.roles?.includes('appReactiveSupport')
        }

        return canRestore;
    }

    canUserHscSupport = (accounts: AccountInfo[], isAuthenticated: boolean) => {
        if (this.isUserAdmin(accounts, isAuthenticated))
            return true;

        let canHscSupport = false;
        if (isAuthenticated && accounts[0] && accounts[0].idTokenClaims) {
            canHscSupport = !!accounts[0].idTokenClaims.roles?.includes('hscSupport')
        }

        return canHscSupport;
    }

    canUserRestoreToSupportServer = (accounts: AccountInfo[], isAuthenticated: boolean) => {
        return this.isUserAdmin(accounts, isAuthenticated)
            || this.canUserHscSupport(accounts, isAuthenticated)
            || this.isUserAPPReactiveSupport(accounts, isAuthenticated);
    }

    canUserUnlinkWorkspace = (accounts: AccountInfo[], isAuthenticated: boolean) => {
        return this.isUserAdmin(accounts, isAuthenticated)
            || this.canUserHscSupport(accounts, isAuthenticated)
            || this.isUserAPPReactiveSupport(accounts, isAuthenticated);
    }

    canUserRetrieveDbBackups = (accounts: AccountInfo[], isAuthenticated: boolean) => {
        return this.isUserAdmin(accounts, isAuthenticated)
            || this.isUserAPPReactiveSupport(accounts, isAuthenticated);
    }

    canUserConfigureACC = (accounts: AccountInfo[], isAuthenticated: boolean) => {
        if (this.isUserAdmin(accounts, isAuthenticated))
            return true;

        let canConfigureACC = false;
        if (isAuthenticated && accounts[0] && accounts[0].idTokenClaims) {
            canConfigureACC = !!accounts[0].idTokenClaims.roles?.includes('configureACC')
        }

        return canConfigureACC;
    }

    canUserLockAccEnvironments = (accounts: AccountInfo[], isAuthenticated: boolean) => {
        if (this.isUserAdmin(accounts, isAuthenticated))
            return true;

        let canLockAccEnv = false;
        if (isAuthenticated && accounts[0] && accounts[0].idTokenClaims) {
            canLockAccEnv = !!accounts[0].idTokenClaims.roles?.includes('lockAccEnv')
        }

        return canLockAccEnv;
    }

    canUserManageSurveyJSTemplates = (accounts: AccountInfo[], isAuthenticated: boolean) => {
        if (this.isUserAdmin(accounts, isAuthenticated))
            return true;

        let canManageSurveyJSTemplates = false;
        if (isAuthenticated && accounts[0] && accounts[0].idTokenClaims) {
            canManageSurveyJSTemplates = !!accounts[0].idTokenClaims.roles?.includes('manageSurveyJsTemplates')
        }

        return canManageSurveyJSTemplates;
    }

    canAccessTelemetryData = (accounts: AccountInfo[], isAuthenticated: boolean) => {
        if (this.isUserAdmin(accounts, isAuthenticated))
            return true;

        let canAccessTelemetry = false;
        if (isAuthenticated && accounts[0] && accounts[0].idTokenClaims) {
            canAccessTelemetry = !!accounts[0].idTokenClaims.roles?.includes('accessTelemetryData')
        }

        return canAccessTelemetry;
    }
}

export default new AppRolesService();
